<div class="">
  <div class="modal-content">
    <div class="modal-body">
      <button (click)="dialog.dismissAll();" type="button" class="btn-close close-outline" data-bs-dismiss="modal">
      </button>
      <div class="signup-update-form">

        @if (mainpopup) {
          <div class="update-form">
            <div class="update-content">
              <h2 class="lp_h2 mb-2">Sign Up for Newsletters</h2>
              <p>Subscribe and stay up-to-date on Family Central news.</p>
              <form class="fc_form" [formGroup]="submitform">
                <div class="form-group">
                  <label for="firstName" class="form-label">First Name <span class="required">*</span></label>
                  <input type="text" autocomplete="off" id="firstName" class="form-control" name="FirstName" required="" formControlName="firstname">
                </div>
                <div class="form-group">
                  <label for="lastName" class="form-label">Last Name <span class="required">*</span></label>
                  <input type="text" autocomplete="off" id="lastName" class="form-control" name="LastName" required="" formControlName="lastname">
                </div>
                <div class="form-group">
                  <label for="login-email" class="form-label">Email <span class="required">*</span></label>
                  <input type="email" autocomplete="off" id="login-email" class="form-control" maxlength="50" name="email" required="" formControlName="email">
                </div>
                <div class="form-group submit_btn">
                  <button type="button" name="submit" id="btn-login" class="primary_btn" [disabled]="submitform.invalid" (click)="submit()">Submit</button>
                </div>
              </form>
            </div>
          </div>
        }

        @if (successpopup) {
          <div class="thank-you-text">
            <h2 class="lp_h2">Thank you!</h2>
            <p>Please check your email to confirm.</p>
          </div>
        }
      </div>
    </div>
  </div>
</div>